<template>
    <div class = "card">
        <div class="card-col-contanier">
            <!-- 必须有card-row-contanier。行排布row套一个card，n个row。列排布row套n个card，n列个row。 -->
            <div class="card-row-contanier">
                <el-card class="card-contanier" :body-style="{ padding: '0px' }" shadow="never">
                    <button class="card-button-contanier" @click="medalDialogVisible = true">
                        <div class="card-image-container" @mouseenter="zoomInImage" @mouseleave="resetImageSize">
                            <img class="card-image" id="image1" fit="none" :src="require('../assets/images/CardVue/1.jpg')" alt="国际竞赛"/>
                            <div class="card-text-container">
                                <span><h1>国际竞赛</h1></span>
                                <span>
                                    <el-button text class="card-button">了解详情<el-icon class="card-el-icon"><View /></el-icon></el-button>
                                    <el-dialog
                                        class="el-dialog-container"
                                        v-model="medalDialogVisible"
                                        @open="handleDialogOpen('image1')"
                                        @closed="handleDialogClosed('image1')"
                                        width="66vw"
                                        :append-to-body="true"
                                        align-center
                                        style="font-family: 'FangYuan'"
                                        destroy-on-close>
                                        <TabVue02></TabVue02>
                                        <!-- <span>Open the dialog from the center from the screen</span> -->
                                    </el-dialog>
                                </span>
                            </div>
                        </div>
                    </button>
                </el-card>
                <el-card class="card-contanier" :body-style="{ padding: '0px' }" shadow="never">
                    <button class="card-button-contanier" @click="switchDialogVisible = true">
                        <div class="card-image-container" @mouseenter="zoomInImage" @mouseleave="resetImageSize">
                            <img class="card-image" id="image2" fit="none" :src="require('../assets/images/CardVue/2.jpg')" alt="国际交流"/>
                            <div class="card-text-container">
                                <span><h1>国际交流</h1></span>
                                <span>
                                    <el-button text class="card-button">了解详情<el-icon class="card-el-icon"><View /></el-icon></el-button>
                                    <el-dialog
                                        class="el-dialog-container"
                                        v-model="switchDialogVisible"
                                        @open="handleDialogOpen('image2')"
                                        @closed="handleDialogClosed('image2')"
                                        width="66vw"
                                        :append-to-body="true"
                                        align-center
                                        style="font-family: 'FangYuan'"
                                        destroy-on-close>
                                        <SwitchVue></SwitchVue>
                                        <!-- <span>Open the dialog from the center from the screen</span> -->
                                    </el-dialog>
                                </span>
                            </div>
                        </div>
                    </button>
                </el-card>
                <el-card class="card-contanier" :body-style="{ padding: '0px' }" shadow="never">
                    <button class="card-button-contanier" @click="campDialogVisible = true">
                        <div class="card-image-container" @mouseenter="zoomInImage" @mouseleave="resetImageSize">
                            <img class="card-image" id="image3" fit="none" :src="require('../assets/images/CardVue/3.jpg')" alt="STEM夏令营"/>
                            <div class="card-text-container">
                                <span><h1>STEM夏令营</h1></span>
                                <span>
                                    <el-button text class="card-button">了解详情<el-icon class="card-el-icon"><View /></el-icon></el-button>
                                    <el-dialog
                                        class="el-dialog-container"
                                        v-model="campDialogVisible"
                                        @open="handleDialogOpen('image3')"
                                        @closed="handleDialogClosed('image3')"
                                        width="66vw"
                                        :append-to-body="true"
                                        align-center
                                        style="font-family: 'FangYuan'"
                                        destroy-on-close>
                                        <CampVue></CampVue>
                                        <!-- <span>Open the dialog from the center from the screen</span> -->
                                    </el-dialog>
                                </span>
                            </div>
                        </div>
                    </button>
                </el-card>
            </div>

            <div class="card-row-contanier">
                <el-card class="card-contanier" :body-style="{ padding: '0px' }" shadow="never">
                    <button class="card-button-contanier" @click="serviceDialogVisible = true">
                        <div class="card-image-container" @mouseenter="zoomInImage" @mouseleave="resetImageSize">
                            <img class="card-image" id="image4" fit="none" :src="require('../assets/images/CardVue/4.jpg')" alt="课程设计"/>
                            <div class="card-text-container">
                                <span><h1>课程设计</h1></span>
                                <span>
                                    <el-button text class="card-button">了解详情<el-icon class="card-el-icon"><View /></el-icon></el-button>
                                    <el-dialog
                                        class="el-dialog-container"
                                        v-model="serviceDialogVisible"
                                        @open="handleDialogOpen('image4')"
                                        @closed="handleDialogClosed('image4')"
                                        width="66vw"
                                        :append-to-body="true"
                                        align-center
                                        style="font-family: 'FangYuan'"
                                        destroy-on-close>
                                        <ServiceVue></ServiceVue>
                                        <!-- <span>Open the dialog from the center from the screen</span> -->
                                    </el-dialog>
                                </span>
                            </div>
                        </div>
                    </button>
                </el-card>
                <el-card class="card-contanier" :body-style="{ padding: '0px' }" shadow="never">
                    <button class="card-button-contanier" @click="schoolDialogVisible = true">
                        <div class="card-image-container" @mouseenter="zoomInImage" @mouseleave="resetImageSize">
                            <img class="card-image" id="image5" fit="none" :src="require('../assets/images/CardVue/5.jpg')" alt="实验室搭建"/>
                            <div class="card-text-container">
                                <span><h1>实验室搭建</h1></span>
                                <span>
                                    <el-button text class="card-button">了解详情<el-icon class="card-el-icon"><View /></el-icon></el-button>
                                    <el-dialog
                                        class="el-dialog-container"
                                        v-model="schoolDialogVisible"
                                        @open="handleDialogOpen('image5')"
                                        @closed="handleDialogClosed('image5')"
                                        width="66vw"
                                        :append-to-body="true"
                                        align-center
                                        style="font-family: 'FangYuan'"
                                        destroy-on-close>
                                        <SchoolVue></SchoolVue>
                                        <!-- <span>Open the dialog from the center from the screen</span> -->
                                    </el-dialog>
                                </span>
                            </div>
                        </div>
                    </button>
                </el-card>
                <el-card class="card-contanier" :body-style="{ padding: '0px' }" shadow="never">
                    <button class="card-button-contanier" @click="trainDialogVisible = true">
                        <div class="card-image-container" @mouseenter="zoomInImage" @mouseleave="resetImageSize">
                            <img class="card-image" id="image6" fit="none" :src="require('../assets/images/CardVue/6.jpg')" alt="赛事培训"/>
                            <div class="card-text-container">
                                <span><h1>赛事培训</h1></span>
                                <span>
                                    <el-button text class="card-button">了解详情<el-icon class="card-el-icon"><View /></el-icon></el-button>
                                    <el-dialog
                                        class="el-dialog-container"
                                        v-model="trainDialogVisible"
                                        @open="handleDialogOpen('image6')"
                                        @closed="handleDialogClosed('image6')"
                                        width="66vw"
                                        :append-to-body="true"
                                        align-center
                                        style="font-family: 'FangYuan'"
                                        destroy-on-close>
                                        <TrainVue></TrainVue>
                                        <!-- <span>Open the dialog from the center from the screen</span> -->
                                    </el-dialog>
                                </span>
                            </div>
                        </div>
                    </button>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import SchoolVue from './SchoolVue.vue';
import ServiceVue from './ServiceVue.vue';
import SwitchVue from './SwitchVue.vue';
import TabVue01 from './TabVue01.vue';
import TabVue02 from './TabVue02.vue';
import CampVue from './CampVue.vue';
import TrainVue from './TrainVue.vue';


export default {
    data() {
        return {
            dialogVisable: false,
            schoolDialogVisible: false,
            serviceDialogVisible: false,
            switchDialogVisible: false,
            medalDialogVisible: false,
            newsDialogVisible: false,
            campDialogVisible: false,
            trainDialogVisible: false,
            titles: [
                {text: "国际竞赛", img: "1.jpg"},
                {text: "国际交流", img: "2.jpg"},
                {text: "STEM夏令营", img: "3.jpg"},
                {text: "课程设计", img: "4.jpg"},
                {text: "实验室搭建", img: "5.jpg"},
                {text: "赛事培训", img: "6.jpg"}
            ]
        }
    },
    methods: {
        zoomInImage(event) {
            const img = event.currentTarget.querySelector('.card-image');
            img.style.transform = "scale(1.2)";
        },
        resetImageSize(event) {
            if (this.dialogVisable === false) {
                const img = event.currentTarget.querySelector('.card-image');
                img.style.transform = "";
            }
        },
        handleDialogOpen(image) {
            this.dialogVisable = true;
            document.getElementById(image).style.transform = 'scale(1.2)';
        },
        handleDialogClosed(image) {
            this.dialogVisable = false;
            document.getElementById(image).style.transform = '';
        },
    },
    components: {
        SchoolVue,
        ServiceVue,
        SwitchVue,
        TabVue01,
        TabVue02,
        CampVue,
        TrainVue
    }
}
</script>

<style lang="scss" scoped>
.card-col-contanier {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    unicode-bidi: isolate;
    justify-content: center;  // 若未填满竖向居中（实验性，横向6展开准备）
}

.card-row-contanier {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
}

.card-contanier {
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    height: 20vw;
}
.card-button-contanier {
    border: none;
    padding: 0;
    background: none;
    cursor: pointer;
    outline: none;
}

.card-image-container {
    position: relative;
    width: 50vw;
}

.card-image-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    overflow: hidden;
    transition: transform 1.2s ease;
}

.card-text-container h1{
    font-family: ShuHei;
    font-size: 2.9vw;
    color: #ffffff;
    // margin: 1.1vw 0.2vw 0.2vw 0.2vw;
    margin: 0.8vw 0.2vw 0.2vw 0.2vw;
}

.card-text-container .card-button {
    font-size: 1vw;
    font-weight: bold;
    letter-spacing: 0.1vw;
    color: #ffffff;
    padding: 0;
    border: 0 solid transparent;
    background-color: transparent;
    width: 7.5vw;
    height: 2vw;
}

.card-text-container .card-button:hover {
    color: #513890
}

.card-text-container .card-el-icon {
    font-size: 1.25vw;
    font-weight: bold;
    border: 0 solid transparent;
    background-color: transparent;
    margin-left: 0.25vw;
}

.card-text-container .span {
    align-items: center;
}

.card-text-container {
    position: absolute;
    top: 10vw;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.4);
    color: #ffffff;
    padding: 0;
    // line-height: 0px;
    height: 7vw;
    width: 50vw;
    text-align: center;
}

@media screen and (max-width: 768px) {
    .card-row-contanier {
        flex: 0 0 100%;
        max-width: 100%;
    }
    
    .card-contanier {
        height: 40vw;
    }

    .card-image-container {
        width: 100vw;
    }

    .card-text-container h1 {
        font-size: 5.8vw;
        // margin: 2.2vw 0.4vw 0.4vw 0.4vw;
        margin: 1.6vw 0.4vw 0.4vw 0.4vw;
    }

    .card-text-container .card-button {
        font-size: 2vw;
        letter-spacing: 0.2vw;
        width: 15vw;
        height: 4vw;
    }

    .card-text-container .card-el-icon {
        font-size: 2.5vw;
        margin-left: 0.5vw;
    }

    .card-text-container {
        top: 20vw;
        height: 14vw;
        width: 100vw;
    }
}
</style>
